import { _ as s, o as c, h as g, r as p } from "./export-cdcbfb2b.js";
import { f as v } from "./function-uncurry-this-clause-99074d1c.js";
import { t as h } from "./to-string-92a62764.js";
import { c as u, n as m } from "./correct-is-regexp-logic-4465cd47.js";
var f = s, l = v, L = c.f, O = g, i = h, R = m, _ = p, b = u, x = l("".slice), C = Math.min, n = b("startsWith"), d = !n && !!function() {
  var r = L(String.prototype, "startsWith");
  return r && !r.writable;
}();
f({ target: "String", proto: !0, forced: !d && !n }, {
  startsWith: function(t) {
    var e = i(_(this));
    R(t);
    var o = O(C(arguments.length > 1 ? arguments[1] : void 0, e.length)), a = i(t);
    return x(e, o, o + a.length) === a;
  }
});
